import { motion } from 'framer-motion';
import { Share2 } from 'lucide-react';
import pollOptionAImg from '@/assets/onboarding/poll-option-a.jpg';
import pollOptionBImg from '@/assets/onboarding/poll-option-b.jpg';
import avatar1 from '@/assets/onboarding/avatar-1.jpg';
import avatar2 from '@/assets/onboarding/avatar-2.jpg';
import avatar3 from '@/assets/onboarding/avatar-3.jpg';
import avatar4 from '@/assets/onboarding/avatar-4.jpg';

const avatarImages = [avatar1, avatar2, avatar3, avatar4];

export function SocialPollsMockup({ isActive = true }: { isActive?: boolean }) {
  return (
    <div className="absolute inset-0 bg-gradient-to-b from-muted to-background flex items-center justify-center px-6">
      <div className="w-full max-w-[300px] space-y-3">
        {/* Friend avatars */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={isActive ? { opacity: 1 } : { opacity: 0 }}
          transition={{ delay: 0.3 }}
          className="flex items-center gap-1 mb-1"
        >
          <div className="flex -space-x-2.5">
            {avatarImages.map((src, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0 }}
                animate={isActive ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0 }}
                transition={{ delay: 0.35 + i * 0.1, type: 'spring' }}
                className="w-8 h-8 rounded-full border-2 border-card overflow-hidden"
              >
                <img src={src} alt="" className="w-full h-full object-cover" />
              </motion.div>
            ))}
          </div>
          <motion.span
            initial={{ opacity: 0 }}
            animate={isActive ? { opacity: 1 } : { opacity: 0 }}
            transition={{ delay: 0.7 }}
            className="text-[11px] text-muted-foreground ml-2"
          >
            4 friends active
          </motion.span>
        </motion.div>

        {/* Poll card */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isActive ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ delay: 0.55, duration: 0.5 }}
          className="bg-card rounded-2xl p-4 shadow-lg border border-border/50"
        >
          <p className="text-xs text-muted-foreground mb-1">@jessica asked</p>
          <p className="text-sm font-semibold text-heading mb-3">Which one for Saturday? 🤔</p>

          {/* Poll options with real images */}
          <div className="flex gap-2 mb-3">
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={isActive ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
              transition={{ delay: 0.75, type: 'spring' }}
              className="flex-1 rounded-xl overflow-hidden border-2 border-primary/30"
            >
              <div className="aspect-square overflow-hidden">
                <img src={pollOptionAImg} alt="Option A" className="w-full h-full object-cover" />
              </div>
              <div className="p-2 bg-primary/5 flex items-center justify-between">
                <span className="text-[11px] font-medium text-heading">Option A</span>
                <motion.span
                  initial={{ opacity: 0 }}
                  animate={isActive ? { opacity: 1 } : { opacity: 0 }}
                  transition={{ delay: 1.1 }}
                  className="text-[11px] font-semibold text-primary"
                >
                  67%
                </motion.span>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={isActive ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
              transition={{ delay: 0.85, type: 'spring' }}
              className="flex-1 rounded-xl overflow-hidden border border-border/50"
            >
              <div className="aspect-square overflow-hidden">
                <img src={pollOptionBImg} alt="Option B" className="w-full h-full object-cover" />
              </div>
              <div className="p-2 flex items-center justify-between">
                <span className="text-[11px] font-medium text-heading">Option B</span>
                <motion.span
                  initial={{ opacity: 0 }}
                  animate={isActive ? { opacity: 1 } : { opacity: 0 }}
                  transition={{ delay: 1.15 }}
                  className="text-[11px] font-semibold text-muted-foreground"
                >
                  33%
                </motion.span>
              </div>
            </motion.div>
          </div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={isActive ? { opacity: 1 } : { opacity: 0 }}
            transition={{ delay: 1.2 }}
            className="text-[10px] text-muted-foreground text-center"
          >
            12 votes · 3h left
          </motion.p>
        </motion.div>

        {/* Shared with you notification */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={isActive ? { opacity: 1, x: 0 } : { opacity: 0, x: -20 }}
          transition={{ delay: 1.1, type: 'spring' }}
          className="bg-card rounded-2xl px-4 py-3 border border-border/50 shadow-sm flex items-center gap-3"
        >
          <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
            <Share2 className="w-4 h-4 text-primary" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-xs font-medium text-heading">Alex shared a collection</p>
            <p className="text-[10px] text-muted-foreground">Summer Wardrobe · 8 items</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
